///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import getPricingGridColumns from "./getPricingGridColumns";
import { isNull, isEmpty } from "lodash";

export const handlePricingCellChange = (
  state,
  { payload: { index, field, value, role } }
) => {
  const { lanes, division, isCoyoteBid } = state;
  const columns = getPricingGridColumns(role, division, null, isCoyoteBid);
  const compare = (original, lane) => {
    for (let p in original) {
      if (original.hasOwnProperty(p)) {
        const column = columns.find(c => c.field === p);
        if (column && column.format) {
          if (column.format(original[p]) !== column.format(lane[p])) {
            return false;
          }
        } else if (
          isNull(original[p]) &&
          isEmpty(lane[p]) &&
          typeof lane[p] !== "number"
        ) {
        } else if (original[p] !== lane[p]) {
          return false;
        }
      }
    }
    return true;
  };
  let lane = lanes.find(l => l.metaData.defaultIndex === index);
  lane[field] = value;
  lane.metaData.change[field] = value !== lane.metaData.originaLane[field];
  lane.metaData.changedByUserValue[field] = value;

  const cellDetails = columns.find(x => x.field === field);

  cellDetails.effects &&
    cellDetails.effects(lane).forEach(effectField => {
      const cell = columns.find(c => c.field === effectField);
      cell && cell.calculate && cell.calculate(lane, field);
    });
  lane.metaData.laneChanged = !compare(lane.metaData.originaLane, lane);
};

export default handlePricingCellChange;
